import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as actions from './actions'

const numbersOfYears = 10
const getYears = () => {
  const currentYear = new Date().getFullYear()

  const years = []

  let i = 0

  for (i; i <= numbersOfYears; i += 1) {
    years.push(currentYear - i)
  }

  return years
}

const initialListFilter = {
  yearsList: getYears(),
  monthsList: [
    { id: '01', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-1" /> },
    { id: '02', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-2" /> },
    { id: '03', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-3" /> },
    { id: '04', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-4" /> },
    { id: '05', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-5" /> },
    { id: '06', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-6" /> },
    { id: '07', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-7" /> },
    { id: '08', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-8" /> },
    { id: '09', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-9" /> },
    {
      id: '10',
      value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-10" />
    },
    {
      id: '11',
      value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-11" />
    },
    {
      id: '12',
      value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-12" />
    }
  ]
}

const INITIAL_CAR_INFORMATIONS = {}

export const carInformationsReducer = (state = INITIAL_CAR_INFORMATIONS, action) => {
  switch (action.type) {
    case actions.SET_CAR_INFORMATIONS: {
      return action.carInformations
    }
    case actions.RESET_CAR_INFORMATIONS: {
      return INITIAL_CAR_INFORMATIONS
    }
    default:
      return state
  }
}

export const INITIAL_STATE = {
  filtersList: {
    yearsList: initialListFilter.yearsList,
    monthsList: initialListFilter.monthsList,
    brandsList: [],
    modelsList: [],
    energiesList: [],
    finishesList: [],
    colorsList: { exterior: null, interior: null },
    designList: {
      exterior: {
        type: []
      },
      interior: { leathers: [], fabrics: [] }
    },
    optionsList: { equipmentGroups: [], equipments: [] },
    defaultsList: []
  },
  vehicle: {
    price: 0,
    prices: {
      totalOptionsPrice: 0,
      totalServiceContractsPrice: 0,
      totalPaintPrice: 0,
      totalSaddleries: 0
    }
  },
  pointOfSales: null,
  makeId: null,
  dealerCode: null,
  futherInformations: null,
  comment: null,
  user: null,
  tradeInprice: null
}

export default function tradeInReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.SET_TRADEIN: {
      return action.tradeIn
    }
    case actions.SET_POINT_OF_SALES: {
      const { pointOfSales, makeId, dealerCode } = action.tradeIn
      return { ...state, pointOfSales, makeId, dealerCode }
    }
    case actions.RESET_TRADE_IN: {
      if (action.keepPointOfSale) {
        const { pointOfSales, makeId, dealerCode } = state
        const { user } = state
        return { ...INITIAL_STATE, pointOfSales, makeId, dealerCode, user }
      }
      return INITIAL_STATE
    }
    default:
      return state
  }
}
